// extracted by mini-css-extract-plugin
export default {"container":"AppReadonlyField_container__b4p8i","value":"AppReadonlyField_value__9movh"};